import React from "react";

import { motion } from "framer-motion";
import "./timeline-scrollhint.scss";

const TimelineScrollHint = ({isActive}) => {

  return (
      <motion.div 
        className="timeline-scrollhint"
        animate={{ opacity: isActive ? 1 : 0 }}
        transition={{ duration: 0.8 }} 
      >
        <span className="timeline-scrollhint__oval">            
            <svg width="24" height="42" viewBox="0 0 24 42" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M2 12.0074V29.9926C2 35.5218 6.47623 40 12 40C17.5235 40 22 35.5204 22 29.9926V12.0074C22 6.47816 17.5238 2 12 2C6.47651 2 2 6.47965 2 12.0074ZM0 12.0074C0 5.3759 5.37113 0 12 0C18.6274 0 24 5.37267 24 12.0074V29.9926C24 36.6241 18.6289 42 12 42C5.37258 42 0 36.6273 0 29.9926V12.0074Z"/>
            </svg>
        </span>
        <span className="timeline-scrollhint__dot">            
            <svg width="2" height="6" viewBox="0 0 2 6" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 1V5C0 5.55228 0.447715 6 1 6C1.55228 6 2 5.55228 2 5V1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1Z"/>
            </svg>
        </span>
        <span className="timeline-scrollhint__arrow">
            <svg width="15" height="9" viewBox="0 0 15 9" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.25451 5.8403L12.7543 0.340463C13.1449 -0.0500618 13.778 -0.0500618 14.1686 0.340463C14.5591 0.730987 14.5591 1.36415 14.1686 1.75468L7.96162 7.96162C7.76636 8.15688 7.51044 8.25452 7.25451 8.25452C6.99859 8.25452 6.74267 8.15688 6.54741 7.96162L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.7071 0.292893L7.25451 5.8403Z"/>
            </svg>
        </span>
      </motion.div>
  );
};

export default TimelineScrollHint;




